exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".msg-text {\n  display: block;\n  width: 60px;\n  font-size: 12px;\n  text-align: center;\n  cursor: pointer;\n}\n.msg-text.display {\n  color: #ccc;\n}\n", ""]);

// exports
